import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { InvoiceDetailEntity } from './invoice-detail.entity';
import { ItemLotEntity } from './item-lot.entity';
import { ItemEntity } from './item.entity';
import { OrderDetailEntity } from './order-detail.entity';
import { PurchaseOrderDetailEntity } from './purchase-order-detail.entity';
import { ShipmentEntity } from './shipment.entity';

@Index('fk_invoice_detail__id', ['fkInvoiceDetailId'], {})
@Index('fk_order_detail__id', ['fkOrderDetailId'], {})
@Index('shipment_detail__fk_item__id_fk', ['fkItemId'], {})
@Index(
	'shipment_detail__fk_item_lot__id__deleted_userId',
	['deletedUserId', 'fkItemLotId'],
	{},
)
@Index('shipment_detail__fk_item_lot__id_fk', ['fkItemLotId'], {})
@Index(
	'shipment_detail__fk_purchase_order_detail__id__deleted_userId',
	['deletedUserId', 'fkPurchaseOrderDetailId'],
	{},
)
@Index(
	'shipment_detail__fk_purchase_order_detail__id_fk',
	['fkPurchaseOrderDetailId'],
	{},
)
@Index('shipment_detail__fk_shipment__id_fk', ['fkShipmentId'], {})
@Index('shipment_detail_externalId_uindex', ['externalId'], { unique: true })
@Index(
	'shipment_detail_itemExternalId_deletedDate',
	['itemExternalId', 'deletedDate'],
	{},
)
@Entity('shipment_detail')
export class ShipmentDetailEntity extends BaseEntity {
	@Column('varchar', {
		name: 'externalId',
		nullable: true,
		unique: true,
		length: 255,
	})
	public externalId!: string | null;

	@Column('varchar', { name: 'itemExternalId', nullable: true, length: 64 })
	public itemExternalId!: string | null;

	@Column('int', { name: '_fk_shipment__id', unsigned: true })
	public fkShipmentId!: number;

	@Column('int', { name: '_fk_item__id', nullable: true, unsigned: true })
	public fkItemId!: number | null;

	@Column('int', { name: '_fk_item_lot__id', nullable: true, unsigned: true })
	public fkItemLotId!: number | null;

	@Column('int', {
		name: 'fk_invoice_detail__id',
		nullable: true,
		unsigned: true,
	})
	public fkInvoiceDetailId!: number | null;

	@Column('int', {
		name: '_fk_purchase_order_detail__id',
		nullable: true,
		unsigned: true,
	})
	public fkPurchaseOrderDetailId!: number | null;

	@Column('int', {
		name: 'fk_order_detail__id',
		nullable: true,
		unsigned: true,
	})
	public fkOrderDetailId!: number | null;

	@Column('varchar', { name: 'description', nullable: true, length: 255 })
	public description!: string | null;

	@Column('int', { name: 'quantity' })
	public quantity!: number;

	@Column('datetime', { name: 'lastImportDate', nullable: true })
	public lastImportDate!: Date | null;

	@ManyToOne(() => ShipmentEntity, (shipment) => shipment.shipmentDetails, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_shipment__id', referencedColumnName: 'id' }])
	public shipment!: ShipmentEntity;

	@ManyToOne(() => ItemEntity, (item) => item.shipmentDetails, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_item__id', referencedColumnName: 'id' }])
	public item!: ItemEntity;

	@ManyToOne(() => ItemLotEntity, (itemLot) => itemLot.shipmentDetails, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_item_lot__id', referencedColumnName: 'id' }])
	public itemLot!: ItemLotEntity;

	@ManyToOne(
		() => InvoiceDetailEntity,
		(invoiceDetail) => invoiceDetail.shipmentDetails,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: 'fk_invoice_detail__id', referencedColumnName: 'id' }])
	public invoiceDetail!: InvoiceDetailEntity;

	@ManyToOne(
		() => PurchaseOrderDetailEntity,
		(purchaseOrderDetail) => purchaseOrderDetail.shipmentDetails,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_purchase_order_detail__id', referencedColumnName: 'id' },
	])
	public purchaseOrderDetail!: PurchaseOrderDetailEntity;

	@ManyToOne(
		() => OrderDetailEntity,
		(orderDetail) => orderDetail.shipmentDetails,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: 'fk_order_detail__id', referencedColumnName: 'id' }])
	public orderDetail!: OrderDetailEntity;
}
